import { render, staticRenderFns } from "./OrderComplete.vue?vue&type=template&id=90cb2fb4&scoped=true"
import script from "./OrderComplete.vue?vue&type=script&lang=js"
export * from "./OrderComplete.vue?vue&type=script&lang=js"
import style0 from "./OrderComplete.vue?vue&type=style&index=0&id=90cb2fb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cb2fb4",
  null
  
)

export default component.exports